import React from 'react'
import { FilterDescriptor } from '@progress/kendo-data-query'
import { Select } from 'antd'
import { BonusCampaignStatus } from 'api/Wallet/Types/MarketingBonusCampaignDto'

interface FilterProps {
  filter: FilterDescriptor
  onFilterChange: (event: { nextFilter: FilterDescriptor }) => void
}

export const BonusCampaignStatusFilter: React.FC<FilterProps> = (props) => {
  const { filter, onFilterChange } = props

  return (
    <Select
      placeholder='Select Status'
      value={filter?.value || undefined}
      onChange={(value) =>
        onFilterChange({
          nextFilter: { ...filter, value },
        })
      }
      style={{ width: '200px' }}
      allowClear
    >
      {BonusCampaignStatus.map((status) => (
        <Select.Option key={status.id} value={status.id}>
          {status.name}
        </Select.Option>
      ))}
    </Select>
  )
}
